export function getFullscreenElement() {
  return (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement ||
    null
  );
}

export function requestBrowserFullscreen(element) {
  if (!element)
    return Promise.reject(new Error("Fullscreen element not found"));

  const request =
    element.requestFullscreen ||
    element.webkitRequestFullscreen ||
    element.mozRequestFullScreen ||
    element.msRequestFullscreen ||
    element.webkitEnterFullscreen ||
    null;

  if (!request) {
    return Promise.reject(
      new Error("Fullscreen API is not supported by this browser"),
    );
  }

  try {
    // Some older webkit methods (webkitEnterFullscreen) are not Promise-based
    const result = request.call(element);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
}

export function exitBrowserFullscreen() {
  const exit =
    document.exitFullscreen ||
    document.webkitExitFullscreen ||
    document.mozCancelFullScreen ||
    document.msExitFullscreen ||
    null;

  if (!exit) return Promise.resolve();

  try {
    return Promise.resolve(exit.call(document));
  } catch (error) {
    return Promise.reject(error);
  }
}
